import { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";
import "./RefreshButton.css";

export function RefreshButton({ onClick, busy = false, disabled = false, label, className, size = 18, text }: {
	onClick: () => void;
	busy?: boolean;
	disabled?: boolean;
	label: string;
	className?: string;
	size?: number;
	text?: string;
}) {
	const [feedback, setFeedback] = useState(false);
	const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
	useEffect(() => () => { if (timer.current !== null) clearTimeout(timer.current); }, []);
	const refreshing = busy || feedback;
	return <button type="button" className={`refresh-button ${className ?? ""}`} title={label}
		aria-label={label} aria-busy={refreshing} disabled={disabled || refreshing}
		onClick={() => {
			setFeedback(true);
			timer.current = setTimeout(() => setFeedback(false), 600);
			onClick();
		}}><RefreshCw size={size} aria-hidden="true" />{text}</button>;
}